<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          2023 © srikrunglifebroker.co.th
        </div>
        <div class="col-md-6">
          <div class="text-md-right footer-links">
            V. {{ appVersion }}
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import {version} from '@/../package'
export default {
  data() {
    return {
      appVersion:version
    }
  },
}
</script>